<template>
  <section class="analyze-container">
    <header class="analyze-header">
      <h1 class="title">Now let’s talk about what’s next.</h1>
      <!-- <p class="subtitle">You’ve shared what you do and what you’re great at — now tell me where you’d like to grow.</p> -->
       <p class="body">Tell me where you’d like to grow.</p>
       <p class="body">What’s the next stage of your career or the next challenge you want to take on?</p>
       <p class="body">What skills do you want to build, what roles are you aiming for, and what kind of work excites you most?</p>
       <p class="body">Whether it’s leadership, new tech, certifications, or better balance, your goals shape how your <strong>Profile</strong> evolves over time.</p>
    </header>
    <div class="analyze-content compensation-section">
      <b-field>
        <b-input
          v-model="aspirations"
          type="textarea"
          placeholder="Tell me about your goals and aspirations — new skills you want to learn, certifications you’re pursuing, or the next role you’re aiming for…

Not sure where to start? Try “I want to move into a cloud architecture role” or “I’d like to manage a small team in the next year” or “I want to find more meaning in my work.”"
          rows="8"
        ></b-input>
      </b-field>
      <p class="field-help-text">Finally, to give you better career insights such as growth paths, benchmarks, and fair market comparisons, please select your current compensation range. This helps personalize your Profile insights later.</p>
      <b-field>
          <b-select
          v-model="compensationRange"
          placeholder="Current compensation range"
          expanded
          >
          <option value="< $50,000">Under $50,000</option>
          <option value="$50,000 – $74,999">$50,000 – $74,999</option>
          <option value="$75,000 – $99,999">$75,000 – $99,999</option>
          <option value="$100,000 – $124,999">$100,000 – $124,999</option>
          <option value="$125,000 – $149,999">$125,000 – $149,999</option>
          <option value="$150,000 – $174,999">$150,000 – $174,999</option>
          <option value="$175,000 – $199,999">$175,000 – $199,999</option>
          <option value="$200,000 +">$200,000 or more</option>
          <option value="">Prefer not to say</option>
        </b-select>
      </b-field>
      <ConsentModal :compensation="sanitizedCompensation" :aspirations="aspirations" />
      <p v-if="error" class="error-msg">{{ error }}</p>
    </div>
    <OnboardingSteps :currentStep="3" />
  </section>
</template>

<script>
import { useAnalyzeStore } from '../stores/analyzeStore'
import OnboardingSteps from '@/components/OnboardingSteps.vue';
import ConsentModal from '@/components/ConsentModal.vue';

export default {
  name: 'AnalyzeAspirations',
  components: {
    OnboardingSteps,
    ConsentModal
  },
  created() {
    if (this.$cookies.isKey("teamwrkr-token")) {
      this.$router.push('/');
    }
    this.analyzeStore = useAnalyzeStore()
  },
  data() {
    return {
      aspirations: '',
      compensationRange: null,
      loading: false,
      error: ''
    };
  },
  computed: {
    sanitizedCompensation() {
      if (!this.compensationRange) {
        return { min: null, max: null }
      }
      const range = this.compensationRange.replace(/\$/g, '').replace(/,/g, '')
      if (range.includes('<')) {
        return { min: 0, max: parseInt(range.replace('< ', '')) }
      } else if (range.includes('+')) {
        return { min: parseInt(range.replace(' +', '')), max: null }
      } else if (range.includes('–')) {
        const [min, max] = range.split('–').map(val => parseInt(val.trim()))
        return { min, max }
      } else {
        return { min: null, max: null }
      }
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.analyze-container {
  background: $color-surface-alt;
  border-radius: 1.2rem;
  box-shadow: 0 4px 32px rgba(170, 118, 214, 0.07);
  padding: 2.5rem 2rem 2rem 2rem;
  max-width: 700px;
  margin: 2.5rem auto;
  color: $color-text;
}

.analyze-header {
  margin-bottom: 2rem;
  text-align: center;

  .title {
    font-size: 2rem;
    font-weight: 700;
    color: $color-primary;
    margin-bottom: 1.7rem;
  }
  .subtitle {
    font-size: 1.15rem;
    color: $color-text-muted;
    margin-bottom: 0.7rem;
    font-style: italic;
  }
  .body {
    font-size: 1.05rem;
    color: $color-text;
    margin-bottom: 0.4rem;
  }
}

.analyze-content {
  background: $color-surface;
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(170, 118, 214, 0.05);
  padding: 2rem 1.2rem 1.5rem 1.2rem;
  margin-bottom: 2rem;
  &.compensation-section {
    .field-help-text {
      margin: 1rem 0;
      padding: 1rem 0;
    }
  }
}

.b-field {
  margin-bottom: 1.5rem;
}

.b-input textarea {
  background: $color-surface-alt;
  border: 1.5px solid $color-primary;
  border-radius: 0.7rem;
  color: $color-text;
  font-size: 1.08rem;
  padding: 1rem;
  transition: border-color 0.18s;
  &:focus {
    border-color: $color-accent;
    outline: none;
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.2rem;
}

.b-button {
  border-radius: 0.7rem;
  font-weight: 700;
  font-size: 1.08rem;
  border: none;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.07);
  &.is-primary {
    background: $color-primary;
    color: $color-surface;
    transition: background 0.18s, color 0.18s;
    &:hover, &:focus {
      background: $color-accent;
      color: $color-surface;
    }
  }
  &.is-secondary {
    background: $color-surface-soft;
    color: $color-primary;
    &:hover, &:focus {
      background: $color-border;
      color: $color-text;
    }
  }
}

.error-msg {
  color: $color-accent;
  font-weight: 600;
  margin-top: 1rem;
}

@media screen and (max-width: 700px) {
  .analyze-container {
    padding: 1.2rem 0.5rem;
    max-width: 99vw;
  }
  .analyze-content {
    padding: 1rem 0.3rem;
  }
}
</style>
